export const normalizeHtml = (html: string): string => {
  return html.replace(/>\s+</g, '><').trim();
};

export const strictHtmlCompare = (html1: string, html2: string): boolean => {
  return normalizeHtml(html1) === normalizeHtml(html2);
};
